class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }
}
customElements.define("m-footer", MFooter);



// Step 1: Access the first iframe (smile-lite-launcher-frame)
const launcherIframe = document.getElementsByClassName('smile-launcher-frame')[0];  // Correct access to the first iframe element

if (launcherIframe) {
    // Step 2: Wait for the first iframe to load
    launcherIframe.onload = function () {
        const iframeDocument = launcherIframe.contentDocument || launcherIframe.contentWindow.document;

        // Step 3: Find the button inside the first iframe (without class or id)
        const button = iframeDocument.querySelector('button'); // The first button tag inside the iframe
        if (button) {
            console.log("Button Found");

            // Step 4: Listen for the button click event inside the first iframe
            button.addEventListener('click', function () {
                console.log("Button Clicked");

                // Step 5: Once the button is clicked, dynamically load the second iframe (smile-panel-frame)
                const iframeContainer = document.getElementById('iframe-container');  // Replace with your iframe container's selector
                iframeContainer.innerHTML = '<iframe id="smile-panel-frame" class="smile-panel-frame" src="https://bubblessugarpopshop.myshopify.com"></iframe>'; // Replace with the second iframe URL

                // Step 6: Wait for the second iframe (smile-panel-frame) to load
                const secondIframe = document.querySelector('#smile-panel-frame'); // Get the second iframe
                if (secondIframe) {
                    console.log("Second Iframe Found");

                    // Wait for second iframe to fully load
                    secondIframe.onload = function () {
                        console.log("Second iframe has fully loaded");

                        // Step 7: Introduce a small delay to ensure that API calls or dynamic content inside iframe are fully loaded
                        setTimeout(() => {
                            const iframeDocument = secondIframe.contentDocument || secondIframe.contentWindow.document;
                            
                            // Step 8: Check if the text element inside the iframe is available
                            const textBox = iframeDocument.querySelector('.powered-by-text');
                            if (textBox) {
                                // Step 9: Change the text content
                                textBox.textContent = 'Your new text here!';
                                console.log('Text updated inside the modal iframe successfully.');
                            } else {
                                console.log('Textbox not found inside the second iframe.');
                            }
                        }, 2000); // Delay of 2000ms (2 seconds) to ensure API calls and content are loaded
                    };
                } else {
                    console.log("Second iframe not found");
                }
            });
        } else {
            console.log('Button not found inside the first iframe.');
        }
    };
} else {
    console.log('First iframe (smile-lite-launcher-frame) not found.');
}
